import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddTutor from "../components/AddTutor";


const AddTutorpage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Tutor  </h5><Breadcrumb title="Add Tutor" /></div>

        {/* AddUserLayer */}
        <AddTutor />

    </>
  );
};

export default AddTutorpage;
